export const dispatchWindowEvent = type => {
  const event = new Event(type);
  window.dispatchEvent(event);
};

export const dispatchWindowCustomEvent = (type, detail = {}) => {
  const event = new CustomEvent(type, { detail });
  window.dispatchEvent(event);
};
